export interface StoreExploreLink {
  to: string
  label: string
}

export const STORE_EXPLORE_LINKS: StoreExploreLink[] = [
  { to: '/shop', label: 'Shop All' },
  { to: '/shop?featured=1', label: 'Featured' },
  { to: '/orders', label: 'Track Order' },
  { to: '/contact', label: 'Contact Us' },
  { to: '/about-us', label: 'About Us' },
  { to: '/shipping-policy', label: 'Shipping Policy' },
  { to: '/return-refund-policy', label: 'Return & Refund' },
  { to: '/terms-and-conditions', label: 'Terms & Conditions' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
]

export function isStoreExploreLinkActive(
  to: string,
  pathname: string,
  search: string
): boolean {
  const params = new URLSearchParams(search)

  if (to === '/shop') {
    return pathname === '/shop' && params.get('featured') !== '1'
  }

  if (to === '/shop?featured=1') {
    return pathname === '/shop' && params.get('featured') === '1'
  }

  return pathname === to
}
